import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { HBox } from '../../../components/Box';
import { selectInvoiceFilter } from '../selectors';
import { InvoiceSearchText } from './SearchText';

const Container = styled.div``;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class InvoiceSearchComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  render() {
    if (!this.props.filter) return null;
    return <InvoiceSearchText filter={this.props.filter} />;
  }
}

InvoiceSearchComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: selectInvoiceFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const InvoiceSearch = compose(withConnect, withRouter)(InvoiceSearchComp);
